//@ts-nocheck
//@ts-ignore
import { Divider, Flex, Stack, Text } from "@chakra-ui/react";
import Pluralize from "pluralize";
import React from "react";
import { setNumberOfHours as setHours } from "../stores/jobs/utils/tutor-fns";
import PriceDisplay from "./payments/PriceDisplay";
type Props = {
  students: any;
  billingInfo: any;
  lessonInfo: any;
};

const EarningsBreakdown = ({
  students,
  billingInfo = {},
  lessonInfo = {},
  ...rest
}: Props) => {
  const earningRate = billingInfo.earningPercentage / 100;
  const lessonsCount = lessonInfo.lessonDuration * lessonInfo.lessonDays.length;
  const hourlyChargeRate = Math.round(
    (setHours(lessonInfo.lessonHours) * billingInfo.hourlyRate) /
      lessonInfo.lessonHours,
  );
  const payoutRate = Math.round(hourlyChargeRate * earningRate);
  const oneStudentPay = payoutRate * lessonInfo.lessonHours * lessonsCount;
  const extraStudentPay = billingInfo.tutorEarnings - oneStudentPay;
  const netEarnings =
    billingInfo.tutorEarnings - billingInfo.firstBookingDiscount;
  const withholdingTax = (netEarnings * billingInfo.withholdingTax) / 100;
  const finalTakeHomePay =
    billingInfo.tutorEarnings +
    billingInfo.transportFare -
    billingInfo.firstBookingDiscount -
    withholdingTax;

  return (
    <Stack className="earnings-breakdown" fontSize={["sm", "md"]} {...rest}>
      <Flex justify="space-between" align="center">
        <Text>Number of lessons</Text>
        <Text>{lessonsCount}</Text>
      </Flex>

      <Flex justify="space-between" align="center">
        <Text>Hours per lesson</Text>
        <Text>{lessonInfo.lessonHours}</Text>
      </Flex>

      <Flex justify="space-between" align="center">
        <Text>Rate charged to client</Text>
        <PriceDisplay
          price={parseFloat(hourlyChargeRate.toFixed(2))}
          fontSize={["sm", "md"]}
          currency={billingInfo.currency}
          priceIsFetched={billingInfo.priceIsFetched}
          fontWeight="normal"
        />
      </Flex>

      <Flex justify="space-between" align="center">
        <Text>Rate paid to you ({billingInfo.earningPercentage}%)</Text>
        <PriceDisplay
          price={parseFloat(payoutRate.toFixed(2))}
          fontSize={["sm", "md"]}
          currency={billingInfo.currency}
          priceIsFetched={billingInfo.priceIsFetched}
          fontWeight="normal"
        />
      </Flex>

      <Divider />

      <Flex mt={2} justify="space-between" align="center">
        <Text>
          {lessonsCount} &times; {Pluralize("hr", lessonInfo.lessonHours, true)}{" "}
          &times; {billingInfo.currency + payoutRate.toLocaleString()} /hr
        </Text>

        <PriceDisplay
          price={parseFloat(oneStudentPay.toFixed(2))}
          fontSize={["sm", "md"]}
          currency={billingInfo.currency}
          priceIsFetched={billingInfo.priceIsFetched}
          fontWeight="normal"
        />
      </Flex>

      {extraStudentPay > 0 && students.length > 1 && (
        <Flex justify="space-between" align="center">
          <Text>
            {Pluralize("additional student", students.length - 1, true)}
          </Text>

          <PriceDisplay
            fontSize={["sm", "md"]}
            price={parseFloat(extraStudentPay.toFixed(2))}
            currency={billingInfo.currency}
            priceIsFetched={billingInfo.priceIsFetched}
            fontWeight="normal"
          />
        </Flex>
      )}

      {billingInfo.firstBookingDiscount > 0 && (
        <Flex justify="space-between" align="center">
          <Text>First booking discount</Text>

          <PriceDisplay
            isMinus
            fontSize={["sm", "md"]}
            color="red.500"
            price={parseFloat(billingInfo.firstBookingDiscount.toFixed(2))}
            currency={billingInfo.currency}
            priceIsFetched={billingInfo.priceIsFetched}
            fontWeight="normal"
          />
        </Flex>
      )}

      <Divider />

      <Flex justify="space-between" align="center">
        <Text fontWeight="medium">Net earnings</Text>

        <PriceDisplay
          fontSize={["sm", "md"]}
          price={parseFloat(netEarnings.toFixed(2))}
          currency={billingInfo.currency}
          priceIsFetched={billingInfo.priceIsFetched}
          fontWeight="medium"
        />
      </Flex>

      {withholdingTax > 0 && (
        <Flex justify="space-between" align="center">
          <Text>Government tax ({billingInfo.withholdingTax}%)</Text>

          <PriceDisplay
            fontSize={["sm", "md"]}
            isMinus
            color="red.500"
            price={parseFloat(withholdingTax.toFixed(2))}
            currency={billingInfo.currency}
            priceIsFetched={billingInfo.priceIsFetched}
            fontWeight="normal"
          />
        </Flex>
      )}

      {billingInfo.transportFare > 0 && (
        <Flex justify="space-between" align="center">
          <Text>Transport stipend</Text>

          <PriceDisplay
            fontSize={["sm", "md"]}
            price={parseFloat(billingInfo.transportFare.toFixed(2))}
            currency={billingInfo.currency}
            priceIsFetched={billingInfo.priceIsFetched}
            fontWeight="normal"
          />
        </Flex>
      )}

      <Divider />

      <Flex my={2} justify="space-between" align="center">
        <Text fontWeight="bold">Your take home</Text>

        <PriceDisplay
          fontSize={["sm", "md"]}
          price={parseFloat(finalTakeHomePay.toFixed(2))}
          currency={billingInfo.currency}
          priceIsFetched={billingInfo.priceIsFetched}
          fontWeight="bold"
        />
      </Flex>
    </Stack>
  );
};

export default EarningsBreakdown;
